// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__1dFKq","btnWrapper":"Footer_btnWrapper__oafY2","copyright":"Footer_copyright__jEuWm","logow":"Footer_logow__aY0yd"};